import React, { useState } from 'react';
import Box from 'atomic/box';
import Link from 'atomic/link';
import Container from 'atomic/container';
import WidgetCategoryListProps from '../widget-category-list.props';
import { WidgetCategoryListInterface } from '../widget-category-list.interface';
import Input from 'atomic/form/input';

import './widget-category-list.desktop.scss';

const WidgetCategoryListDesktop: React.FC<WidgetCategoryListProps> = props => {
    const [filteredData, setFilteredData] = useState<WidgetCategoryListInterface[]>([...props.data.children]);
    const [searchedText, setSearchedText] = useState<string>('');

    const valueChange = (event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>): void => {
        const text = event.currentTarget.value;

        if (text) {
            const newArray: WidgetCategoryListInterface[] = [];

            props.data.children.forEach(cat => {
                newArray.push({
                    ...cat,
                    children: [...cat.children.filter(item => item.name.toLowerCase().includes(text.toLowerCase()))]
                });
            });
            setSearchedText(text);
            setFilteredData(newArray.filter(cat => cat.name.toLowerCase().includes(text.toLowerCase()) || cat.children.length > 0));
        } else {
            setFilteredData([...props.data.children]);
        }
    };

    return (
        <Container className="w-category-list-desktop">
            <h2>
                Wyszukaj kategorię
                {' '}
                <b>
                    w dziale
                    {' '}
                    {props.data.name}
                </b>
            </h2>
            <div className="w-category-list-desktop__search">
                <Input
                    name="search-category"
                    label="Zacznij wpisywać nazwę kategorii, której szukasz"
                    aria-label="Search"
                    onChange={(event) => valueChange(event)}
                    icon={{ name: 'search', title: 'Szukaj' }}
                    small={true}
                />

            </div>
            {
                filteredData.length > 0
                    ? (
                        <Box className="w-category-list-desktop__list">
                            {filteredData.map(category => (
                                <div className="w-category-list-desktop__list-item" key={category.name}>
                                    <h2>
                                        <a href={category.url}>
                                            {category.name}
                                        </a>
                                    </h2>
                                    <ul>
                                        {category.children.map(item => (
                                            <li key={item.id}>
                                                <Link className="w-category-list-desktop__list-link" href={item.url}
                                                    title={item.name}
                                                    size="md"
                                                    weight="400"
                                                >
                                                    {item.name}
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            ))}
                        </Box>
                    )
                    : (
                        <div className="w-category-list-desktop__list-empty">
                            <p>
                                <b>
                                    Brak wyników dla
                                </b>
                                :
                                {' '}
                                <span>
                                    {searchedText}
                                </span>
                            </p>
                            <p>
                                Nie odnaleźliśmy poszukiwanej przez Ciebie kategorii w dziale, w którym się znajdujesz.
                                Spróbuj skorzystać z
                                {' '}
                                <a href="#">
                                    wyszukiwarki głównej
                                </a>
                                {''}
                                .
                            </p>
                        </div>
                    )
            }
        </Container>
    );
};

export default WidgetCategoryListDesktop;
